import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React__default from 'react';
import PaginationProvider from './Pagination/PaginationProvider.js';
import { TableAdvanced } from './TableAdvanced.js';

var _excluded = ["alternateRowColor", "cellPadding", "className", "data", "data-testid", "fixedHeader", "height", "name", "pagination", "rowSelection", "showGrid", "scrollableWidth"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var TablePaginationWrapper = function TablePaginationWrapper(_ref) {
  var _data$rowData;
  var alternateRowColor = _ref.alternateRowColor,
    _ref$cellPadding = _ref.cellPadding,
    cellPadding = _ref$cellPadding === void 0 ? 'normal' : _ref$cellPadding,
    className = _ref.className,
    data = _ref.data,
    dataTestId = _ref['data-testid'],
    fixedHeader = _ref.fixedHeader,
    height = _ref.height,
    name = _ref.name,
    pagination = _ref.pagination,
    rowSelection = _ref.rowSelection,
    _ref$showGrid = _ref.showGrid,
    showGrid = _ref$showGrid === void 0 ? true : _ref$showGrid,
    _ref$scrollableWidth = _ref.scrollableWidth,
    scrollableWidth = _ref$scrollableWidth === void 0 ? false : _ref$scrollableWidth,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(PaginationProvider, _objectSpread({
    // totalItems is optional for client side
    totalItems: data === null || data === void 0 ? void 0 : (_data$rowData = data.rowData) === null || _data$rowData === void 0 ? void 0 : _data$rowData.length
  }, pagination), /*#__PURE__*/React__default.createElement(TableAdvanced, _extends({
    alternateRowColor: alternateRowColor,
    cellPadding: cellPadding,
    className: className,
    data: data,
    dataTestId: dataTestId,
    fixedHeader: fixedHeader,
    height: height,
    name: name,
    pagination: pagination,
    rowSelection: rowSelection,
    showGrid: showGrid,
    scrollableWidth: scrollableWidth
  }, otherProps)));
};

export { TablePaginationWrapper as default };
